const baseUrl="/master-data";
const items = [
  {
    icon: "far fa-address-card",
    text: "Outlet",
    link: baseUrl + "/outlets",
    level:3
  },
  {
    icon: "fas fa-tags",
    text: "General Setup",
    link: baseUrl + "/general-setup",
    level:3
  },
  {
    icon: "fas fa-tags",
    text: "Parameter",
    link: baseUrl + "/parameter",
    level:3
  },
  {
    icon: "mdi-transfer",
    text: "Intercompany Mapping",
    link: baseUrl + "/intercompany-mapping",
    level:3
  },
  {
    icon: "fas fa-address-card",
    text: "Article Product Type",
    link: baseUrl + "/articles-product-types",
    level:3
  },
  {
    icon: "fas fa-address-card",
    text: "Article",
    link: baseUrl + "/articles",
    level:3
  },
  {
    icon: "fas fa-address-card",
    text: "Article Group",
    link: baseUrl + "/articles-groups",
    level:3
  },
  {
    icon: "fas fa-address-card",
    text: "Article Group Setup",
    link: baseUrl + "/articles-groups-articles",
    level:3
  },
  {
    icon: "fas fa-object-group",
    text: "Article Group Outlet Setup",
    link: baseUrl + "/article-group-outlets",
    level:3
  },
  {
    icon: "fas fa-handshake",
    text: "Article Flavour Group",
    link: baseUrl + "/article-flavour-group",
    level:3
  },
  {
    icon: "fas fa-handshake",
    text: "Article Flavour",
    link: baseUrl + "/article-flavour",
    level:3
  },
  {
    icon: "fas fa-handshake",
    text: "Article Flavour Group Article Group Setup",
    link: baseUrl + "/article-flavour-article-group",
    level:3
  },
  {
    icon: "fas fa-handshake",
    text: "Collection Category",
    link: baseUrl + "/collection-categories",
    level:3
  },
  {
    icon: "fas fa-handshake",
    text: "Collection Type",
    link: baseUrl + "/collection-types",
    level:3
  },
  {
    icon: "fas fa-handshake",
    text: "Collection Identification Group",
    link: baseUrl + "/collection-identification-group",
    level:3
  },
  {
    icon: "fas fa-handshake",
    text: "Collection Identification",
    link: baseUrl + "/collection-identification",
    level:3
  },
  {
    icon: "fas fa-handshake",
    text: "Collection Type Outlet Setup",
    link: baseUrl + "/collection-type-outlets",
    level:3
  },
  {
    icon: "fas fa-tags",
    text: "Price",
    link: baseUrl + "/prices",
    level:3
  },
  {
    icon: "mdi-clipboard-text-clock",
    text: "Meal Time Setup",
    link: baseUrl + "/meal-time-setup",
    level:3
  },
  {
    icon: "fas fa-tag",
    text: "Discount",
    link: baseUrl + "/discount",
    level:3
  },
  {
    icon: "mdi-order-numeric-ascending",
    text: "Course Stage",
    link: baseUrl + "/course-stage",
    level:3
  },
  {
    icon: "mdi-desk",
    text: "Table",
    link: baseUrl + "/table",
    level:3
  },
  {
    icon: "mdi-printer",
    text: "Printer Type",
    link: baseUrl + "/printer-type",
    level:3
  },
  {
    icon: "mdi-printer",
    text: "Printer",
    link: baseUrl + "/printer",
    level:3
  },
  {
    icon: "mdi-monitor",
    text: "Screen",
    link: baseUrl + "/screen",
    level:3
  },
  {
    icon: "mdi-package",
    text: "Package",
    link: baseUrl + "/package",
    level:3
  },
  {
    icon: "fas fa-spray-can",
    text: "Guest Profiles",
    link: baseUrl + "/guest-profiles",
    level: 3,
  },
];

export default items;
